import { render } from "./SearchWidgetCustomElement.vue?vue&type=template&id=84894e86&scoped=true"
import script from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"
export * from "./SearchWidgetCustomElement.vue?vue&type=script&lang=js"

import "./SearchWidgetCustomElement.vue?vue&type=style&index=0&id=84894e86&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src130321472/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84894e86"]])

export default __exports__